module.exports = __webpack_public_path__ + "static/media/analitycs1.8a53550c.svg";